function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f0efef;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #717070;\n      }\n\n      .cls-3 {\n        fill: #919191;\n      }\n\n      .cls-4 {\n        fill: #e7ac8f;\n      }\n\n      .cls-5 {\n        fill: #343332;\n      }\n\n      .cls-6 {\n        fill: #010101;\n      }\n\n      .cls-7 {\n        fill: #b01e47;\n      }\n\n      .cls-8 {\n        fill: #fff;\n      }\n\n      .cls-9 {\n        fill: #878787;\n      }\n\n      .cls-10 {\n        fill: #ee2157;\n      }\n\n      .cls-11 {\n        fill: #4e4e4d;\n      }\n\n      .cls-12 {\n        fill: #585856;\n      }\n    "));

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 603.4,
  y: 484.33,
  width: 10.11,
  height: 232.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 643.79,
  y: 452.74,
  width: 10.11,
  height: 263.93
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 684.18,
  y: 452.74,
  width: 10.11,
  height: 263.93
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 724.57,
  y: 452.74,
  width: 10.11,
  height: 263.93
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 603.4,
  y: 705.41,
  width: 131.28,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 603.4,
  y: 673.83,
  width: 131.28,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 603.4,
  y: 642.25,
  width: 131.28,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 603.4,
  y: 610.66,
  width: 131.28,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 603.4,
  y: 579.08,
  width: 131.28,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 603.4,
  y: 547.49,
  width: 131.28,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 603.4,
  y: 515.91,
  width: 131.28,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 643.79,
  y: 484.33,
  width: 90.89,
  height: 4.35
})), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 643.79,
  y: 547.49,
  width: 90.89,
  height: 169.18
})), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 387.31,
  y: 452.74,
  width: 67.55,
  height: 263.93
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 448.71,
  y: 421.16,
  width: 6.14,
  height: 295.51
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 475.48,
  y: 421.16,
  width: 6.14,
  height: 295.51
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 502.25,
  y: 421.16,
  width: 6.14,
  height: 295.51
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 529.02,
  y: 452.74,
  width: 6.14,
  height: 263.93
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 481.63,
  y: 421.16,
  width: 6.7,
  height: 295.51
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 508.4,
  y: 421.16,
  width: 6.7,
  height: 295.51
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 535.17,
  y: 452.74,
  width: 6.7,
  height: 263.93
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 481.63,
  y: 547.49,
  width: 33.47,
  height: 169.18
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 515.1,
  y: 667.3,
  width: 20.07,
  height: 6.53
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 515.1,
  y: 698.89,
  width: 20.07,
  height: 17.79
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 515.1,
  y: 635.72,
  width: 20.07,
  height: 6.53
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 515.1,
  y: 604.14,
  width: 20.07,
  height: 6.53
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 454.86,
  y: 421.16,
  width: 6.7,
  height: 295.51
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 454.86,
  y: 705.41,
  width: 87.01,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 454.86,
  y: 673.83,
  width: 87.01,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 454.86,
  y: 642.25,
  width: 87.01,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 454.86,
  y: 610.66,
  width: 87.01,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 454.86,
  y: 579.08,
  width: 87.01,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 454.86,
  y: 547.49,
  width: 87.01,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 454.86,
  y: 515.91,
  width: 87.01,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 454.86,
  y: 484.33,
  width: 87.01,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 454.86,
  y: 452.74,
  width: 60.24,
  height: 4.35
})), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 454.86,
  y: 452.74,
  width: 33.47,
  height: 263.93
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 494.23,
  y: 615.01,
  width: 8.25,
  height: 20.71
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 494.23,
  y: 646.6,
  width: 8.25,
  height: 20.71
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 494.23,
  y: 678.18,
  width: 8.25,
  height: 20.71
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 494.23,
  y: 583.43,
  width: 8.25,
  height: 20.71
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 494.23,
  y: 551.84,
  width: 8.25,
  height: 20.71
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 498.36,
  y: 615.01,
  width: 4.13,
  height: 20.71
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 498.36,
  y: 646.6,
  width: 4.13,
  height: 20.71
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 498.36,
  y: 678.18,
  width: 4.13,
  height: 20.71
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 498.36,
  y: 583.43,
  width: 4.13,
  height: 20.71
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 498.36,
  y: 551.84,
  width: 4.13,
  height: 20.71
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m212.84,669.77c47.83-28.51,124.03-14.36,156.15,43.39H64.94c16.3-16.66,41.2-28.23,65.9-24.95,23.45,3.12,42.58,5.05,82-18.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m221.67,676.25c61.8-32.65,117.02-12.22,147.32,36.91H99.59c-8.39,0-13.85-8.05-5.71-14.16,10.26-7.69,22.54-10.82,40-8.48,28.55,3.83,50.44,5.46,87.8-14.28Z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 246.29,
  y: 327.61,
  width: 80.78,
  height: 390.26
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 327.07,
  y: 327.61,
  width: 53.54,
  height: 390.26,
  transform: "translate(707.68 1045.49) rotate(180)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 195.79,
  y: 327.61,
  width: 10.11,
  height: 390.26
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 236.18,
  y: 327.61,
  width: 10.11,
  height: 390.26
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 276.57,
  y: 327.61,
  width: 10.11,
  height: 390.26
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 316.96,
  y: 327.61,
  width: 10.11,
  height: 390.26
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 205.9,
  y: 327.61,
  width: 6.14,
  height: 390.26
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 246.29,
  y: 327.61,
  width: 6.14,
  height: 390.26
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 286.68,
  y: 327.61,
  width: 6.14,
  height: 390.26
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 195.79,
  y: 706.62,
  width: 131.28,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 195.79,
  y: 675.03,
  width: 131.28,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 195.79,
  y: 643.45,
  width: 131.28,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 195.79,
  y: 611.86,
  width: 131.28,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 195.79,
  y: 580.28,
  width: 131.28,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 195.79,
  y: 548.7,
  width: 131.28,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 195.79,
  y: 517.11,
  width: 131.28,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 195.79,
  y: 485.53,
  width: 131.28,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 195.79,
  y: 453.95,
  width: 131.28,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 195.79,
  y: 422.36,
  width: 131.28,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 195.79,
  y: 390.78,
  width: 131.28,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 195.79,
  y: 359.19,
  width: 131.28,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 195.79,
  y: 327.61,
  width: 131.28,
  height: 4.35
})), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 246.29,
  y: 264.44,
  width: 80.78,
  height: 63.17
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 194.06,
  y: 296.03,
  width: 11.84,
  height: 31.58
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 205.9,
  y: 296.03,
  width: 7.87,
  height: 31.58
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 234.45,
  y: 296.03,
  width: 11.84,
  height: 31.58
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 246.29,
  y: 296.03,
  width: 7.87,
  height: 31.58
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 274.84,
  y: 296.03,
  width: 11.84,
  height: 31.58
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 286.68,
  y: 296.03,
  width: 7.87,
  height: 31.58
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 315.23,
  y: 296.03,
  width: 11.84,
  height: 31.58
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 407.38,
  y: 327.61,
  width: 6.7,
  height: 390.26
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 380.61,
  y: 327.61,
  width: 6.7,
  height: 390.26
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 353.84,
  y: 327.61,
  width: 6.7,
  height: 390.26
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 327.07,
  y: 327.61,
  width: 6.7,
  height: 390.26
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 401.24,
  y: 327.61,
  width: 6.14,
  height: 390.26
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 374.47,
  y: 327.61,
  width: 6.14,
  height: 390.26
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 347.7,
  y: 327.61,
  width: 6.14,
  height: 390.26
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 327.07,
  y: 264.44,
  width: 53.54,
  height: 63.17,
  transform: "translate(707.68 592.05) rotate(180)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 327.07,
  y: 296.03,
  width: 7.87,
  height: 31.58
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 346.53,
  y: 296.03,
  width: 7.31,
  height: 31.58
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 353.84,
  y: 296.03,
  width: 7.87,
  height: 31.58
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 373.3,
  y: 296.03,
  width: 7.31,
  height: 31.58
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 380.61,
  y: 296.03,
  width: 7.87,
  height: 31.58
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 400.07,
  y: 296.03,
  width: 7.31,
  height: 31.58
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 407.38,
  y: 296.03,
  width: 7.87,
  height: 31.58
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 327.07,
  y: 706.62,
  width: 87.01,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 327.07,
  y: 675.03,
  width: 87.01,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 327.07,
  y: 643.45,
  width: 87.01,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 327.07,
  y: 611.86,
  width: 87.01,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 327.07,
  y: 580.28,
  width: 87.01,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 327.07,
  y: 548.7,
  width: 87.01,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 327.07,
  y: 517.11,
  width: 87.01,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 327.07,
  y: 485.53,
  width: 87.01,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 327.07,
  y: 453.95,
  width: 87.01,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 327.07,
  y: 422.36,
  width: 87.01,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 327.07,
  y: 390.78,
  width: 87.01,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 327.07,
  y: 359.19,
  width: 87.01,
  height: 4.35
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 327.07,
  y: 327.61,
  width: 87.01,
  height: 4.35
})), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 249.36,
  y: 700.09,
  width: 27.21,
  height: 6.53
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 195.26,
  y: 297.5,
  width: 9.44,
  height: 1.47
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 195.26,
  y: 304.29,
  width: 9.44,
  height: 1.47
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 195.26,
  y: 311.09,
  width: 9.44,
  height: 1.47
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 195.26,
  y: 317.88,
  width: 9.44,
  height: 1.47
})), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 208.97,
  y: 700.09,
  width: 27.21,
  height: 6.53
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 289.75,
  y: 700.09,
  width: 27.21,
  height: 6.53
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 235.65,
  y: 297.5,
  width: 9.44,
  height: 1.47
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 235.65,
  y: 304.29,
  width: 9.44,
  height: 1.47
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 235.65,
  y: 311.09,
  width: 9.44,
  height: 1.47
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 235.65,
  y: 317.88,
  width: 9.44,
  height: 1.47
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 276.04,
  y: 297.5,
  width: 9.44,
  height: 1.47
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 276.04,
  y: 304.29,
  width: 9.44,
  height: 1.47
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 276.04,
  y: 311.09,
  width: 9.44,
  height: 1.47
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 276.04,
  y: 317.88,
  width: 9.44,
  height: 1.47
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 316.43,
  y: 297.5,
  width: 9.44,
  height: 1.47
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 316.43,
  y: 304.29,
  width: 9.44,
  height: 1.47
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 316.43,
  y: 311.09,
  width: 9.44,
  height: 1.47
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 316.43,
  y: 317.88,
  width: 9.44,
  height: 1.47
})), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 249.36,
  y: 668.51,
  width: 27.21,
  height: 6.53
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 208.97,
  y: 668.51,
  width: 27.21,
  height: 6.53
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 289.75,
  y: 668.51,
  width: 27.21,
  height: 6.53
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 249.36,
  y: 636.92,
  width: 27.21,
  height: 6.53
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 208.97,
  y: 636.92,
  width: 27.21,
  height: 6.53
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 289.75,
  y: 636.92,
  width: 27.21,
  height: 6.53
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 249.36,
  y: 605.34,
  width: 27.21,
  height: 6.53
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 208.97,
  y: 605.34,
  width: 27.21,
  height: 6.53
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 289.75,
  y: 605.34,
  width: 27.21,
  height: 6.53
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 249.36,
  y: 573.76,
  width: 27.21,
  height: 6.53
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 208.97,
  y: 573.76,
  width: 27.21,
  height: 6.53
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 289.75,
  y: 573.76,
  width: 27.21,
  height: 6.53
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 289.75,
  y: 542.17,
  width: 27.21,
  height: 6.53
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 347.58,
  y: 297.5,
  width: 5.21,
  height: 1.47
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 347.58,
  y: 304.29,
  width: 5.21,
  height: 1.47
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 347.58,
  y: 311.09,
  width: 5.21,
  height: 1.47
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 347.58,
  y: 317.88,
  width: 5.21,
  height: 1.47
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 374.35,
  y: 297.5,
  width: 5.21,
  height: 1.47
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 374.35,
  y: 304.29,
  width: 5.21,
  height: 1.47
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 374.35,
  y: 311.09,
  width: 5.21,
  height: 1.47
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 374.35,
  y: 317.88,
  width: 5.21,
  height: 1.47
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 401.12,
  y: 297.5,
  width: 5.21,
  height: 1.47
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 401.12,
  y: 304.29,
  width: 5.21,
  height: 1.47
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 401.12,
  y: 311.09,
  width: 5.21,
  height: 1.47
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 401.12,
  y: 317.88,
  width: 5.21,
  height: 1.47
})), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 327.07,
  y: 548.7,
  width: 33.47,
  height: 67.52
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 249.36,
  y: 710.97,
  width: 27.21,
  height: 6.91
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 208.97,
  y: 710.97,
  width: 27.21,
  height: 6.91
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 289.75,
  y: 710.97,
  width: 27.21,
  height: 6.91
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 327.07,
  y: 611.86,
  width: 87.01,
  height: 106.01
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 366.45,
  y: 647.8,
  width: 8.25,
  height: 20.71
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 366.45,
  y: 616.22,
  width: 8.25,
  height: 20.71
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 366.45,
  y: 679.38,
  width: 8.25,
  height: 20.71
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 370.57,
  y: 616.22,
  width: 4.13,
  height: 20.71
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 370.57,
  y: 647.8,
  width: 4.13,
  height: 20.71
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 370.57,
  y: 679.38,
  width: 4.13,
  height: 20.71
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "m221.32,682.07c61.8-32.65,117.02-12.22,147.32,36.91H99.24c-8.39,0-13.85-8.05-5.71-14.16,10.26-7.69,22.54-10.82,40-8.48,28.55,3.83,50.44,5.46,87.8-14.28Z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m582.97,161.46v556.41h9.14v-2.64h-6.51v-18.64l18.58,20.47v.81h2.64V161.46h-23.85Zm2.64,88.87h6.51v-2.64h-6.51v-18.64l18.12,19.96-18.12,19.96v-18.65Zm0,46.76h6.51v-2.64h-6.51v-18.64l18.12,19.96-18.12,19.96v-18.64Zm0,46.75h6.51v-2.64h-6.51v-18.64l18.12,19.96-18.12,19.96v-18.65Zm0,46.76h6.51v-2.64h-6.51v-18.64l18.12,19.96-18.12,19.96v-18.64Zm0,46.76h6.51v-2.64h-6.51v-18.65l18.12,19.96-18.12,19.96v-18.64Zm0,46.75h6.51v-2.64h-6.51v-18.64l18.12,19.96-18.12,19.96v-18.65Zm0,46.76h6.51v-2.64h-6.51v-18.65l18.12,19.96-18.12,19.96v-18.64Zm0,46.75h6.51v-2.64h-6.51v-18.64l18.12,19.96-18.12,19.96v-18.65Zm0,46.76h6.51v-2.64h-6.51v-18.64l18.12,19.96-18.12,19.96v-18.64Zm0,46.75h6.51v-2.64h-6.51v-18.64l18.12,19.96-18.12,19.96v-18.65Zm18.58,42.02l-16.92-18.65h4.85v-2.64h-4.85l16.92-18.64v39.93Zm0-46.76l-16.92-18.64h4.85v-2.64h-4.85l16.92-18.65v39.93Zm0-46.76l-16.92-18.64h4.85v-2.64h-4.85l16.92-18.64v39.92Zm0-46.75l-16.92-18.64h4.85v-2.64h-4.85l16.92-18.65v39.93Zm0-46.76l-16.92-18.64h4.85v-2.64h-4.85l16.92-18.64v39.92Zm0-46.75l-16.92-18.65h4.85v-2.64h-4.85l16.92-18.64v39.93Zm0-46.76l-16.92-18.64h4.85v-2.64h-4.85l16.92-18.65v39.93Zm0-46.75l-16.92-18.65h4.85v-2.64h-4.85l16.92-18.64v39.93Zm0-46.76l-16.92-18.64h4.85v-2.64h-4.85l16.92-18.65v39.93Zm0-46.76l-16.92-18.64h4.85v-2.64h-4.85l16.92-18.64v39.92Zm0-46.75l-16.92-18.64h4.85v-2.64h-4.85l16.92-18.65v39.93Zm0-43.85l-18.58,20.47v-18.64h6.51v-2.64h-6.51v-36.84h18.58v37.65Z"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-8",
  points: "598.19 68.26 597.89 68.51 671.45 147.24 671.75 147"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-8",
  points: "598.01 69.16 598.07 67.61 423.9 146.34 423.84 147.9"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 667.95,
  y: 146.86,
  width: 7.83,
  height: 31.85
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 675.78,
  y: 146.86,
  width: 58.53,
  height: 31.85
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "414.41 229.93 414.53 229.53 379.94 205.52 363.53 229.14 363.93 230.32 380.22 207.09 414.41 229.93"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "346.81 229.93 379.94 207.09 396.23 230.32 397.69 229.14 380.75 204.99 380.29 205.31 346.16 229 346.81 229.93"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 364,
  y: 229.47,
  width: 50.74,
  height: 8.02,
  transform: "translate(778.73 466.95) rotate(180)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-9",
  x: 346.48,
  y: 229.47,
  width: 17.51,
  height: 8.02
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "m380.61,208.72c2.72,0,4.94-2.21,4.94-4.94h-2.26c0,1.48-1.2,2.68-2.68,2.68s-2.68-1.2-2.68-2.68c0-.79.38-1.42.69-1.8.15-.18.42-.4.7-.64.96-.8,2.41-2.01,2.41-4.17h-2.26c0,1.03-.63,1.63-1.6,2.43-.37.31-.72.6-1,.94-.79.96-1.74,2.61-1.74,3.77,0,2.72,2.74,4.41,5.46,4.41Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "391.56 183.74 391.56 190.82 380.61 197.9 369.66 190.82 369.66 183.74 391.56 183.74"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "389.19 183.74 389.79 184.27 389.79 170.39 389.19 169.86 389.19 183.74"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "370.37 184.27 372.03 183.74 372.03 169.86 370.37 170.39 370.37 184.27"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m317.03,163.24c.19.52.68.87,1.24.87h21.9s0,0,0,0c0,0,.01,0,.02,0,.07,0,.15,0,.22-.02,0,0,0,0,.01,0,0,0,0,0,0,0,.03,0,.05-.01.07-.02.05-.01.1-.03.15-.04.01,0,.02,0,.03-.01.02,0,.04-.02.07-.03.04-.02.08-.04.12-.07.03-.02.06-.04.1-.07.02-.02.04-.03.06-.05l16.97-14.47,2.79,13.73s.02.05.02.07c0,.04.02.07.03.11.02.05.04.09.06.14.01.03.03.06.04.08.04.06.08.12.12.17,0,0,.01.02.02.03,0,0,0,0,0,0,.06.07.12.13.19.18.02.02.04.03.07.04.05.03.1.06.16.09.03.01.05.03.08.04.06.02.12.04.18.06.02,0,.04.01.07.02.08.02.17.03.26.03,0,0,0,0,.01,0,.08,0,.16,0,.24-.02,0,0,0,0,.01,0,.02,0,.04-.01.05-.02.06-.01.11-.03.17-.05.03-.01.06-.03.09-.04.04-.02.08-.04.12-.07.03-.02.06-.04.1-.07.02-.02.04-.03.06-.04l16.84-14.48,2.92,13.75s.02.05.02.07c0,.03.02.07.03.1.02.05.04.09.06.14.01.03.03.05.04.08.04.06.08.12.12.17,0,0,.01.02.02.03,0,0,0,0,0,0,.06.07.12.13.19.18.02.02.04.03.07.04.05.03.1.06.16.09.03.01.05.03.08.04.06.02.12.04.18.06.02,0,.04.01.07.02.08.02.17.03.25.03,0,0,0,0,0,0,.08,0,.17-.01.25-.03,0,0,.01,0,.02,0,.02,0,.04-.01.06-.02.05-.01.11-.03.16-.05.03-.01.06-.03.09-.04.04-.02.08-.04.12-.07.03-.02.07-.05.1-.07.02-.01.04-.02.06-.04l16.71-14.48,3.05,13.77s.01.04.02.07c0,.03.02.07.03.1.02.05.04.09.06.14.01.03.03.05.04.08.03.06.07.11.11.16,0,.01.01.02.02.03,0,0,0,0,0,0,.06.07.12.12.19.18.02.02.04.03.07.04.05.03.1.06.15.09.03.01.05.03.08.04.06.02.11.04.17.06.02,0,.05.01.07.02.08.02.17.03.25.03,0,0,0,0,.01,0,.08,0,.17-.01.25-.03,0,0,.01,0,.02,0,.02,0,.04-.01.06-.02.05-.01.11-.03.16-.05.03-.01.06-.03.09-.04.04-.02.08-.04.12-.07.03-.02.06-.04.1-.07.02-.01.04-.02.05-.04l16.57-14.48,3.18,13.78s.01.04.02.06c0,.04.02.07.03.1.02.05.04.09.06.13.01.03.03.06.04.08.03.06.07.11.11.16,0,.01.02.03.03.04,0,0,0,0,0,0,.06.06.12.12.19.17.02.02.04.03.06.04.05.03.1.06.16.09.03.01.05.02.08.04.06.02.11.04.17.06.02,0,.04.01.07.02.08.02.17.03.25.03,0,0,0,0,0,0,.09,0,.18-.01.26-.03,0,0,.02,0,.03,0,.02,0,.04-.01.06-.02.05-.01.1-.03.15-.05.03-.01.06-.03.09-.04.04-.02.08-.05.12-.07.03-.02.06-.04.09-.07.02-.01.04-.02.05-.04l16.44-14.48,3.31,13.8s.01.04.02.06c0,.03.02.07.03.1.02.05.04.09.06.13.01.03.03.05.04.08.03.06.07.11.11.16,0,.01.02.02.03.04,0,0,0,0,0,0,.06.06.12.12.19.17.02.02.04.03.06.04.05.03.1.06.16.09.03.01.05.02.08.04.06.02.11.04.17.06.02,0,.04.01.07.02.08.02.17.03.25.03,0,0,0,0,0,0,.09,0,.18-.01.27-.03,0,0,.02,0,.03,0,.02,0,.04-.01.06-.02.05-.01.1-.03.15-.05.03-.01.06-.03.1-.05.04-.02.08-.04.12-.07.03-.02.07-.05.1-.07.02-.01.03-.02.05-.04l16.31-14.48,3.44,13.81s.01.04.02.06c0,.03.02.06.03.1.02.05.04.09.06.14.01.03.03.05.04.08.03.06.07.11.12.16,0,.01.01.02.02.03,0,0,0,0,0,0,.06.06.12.12.19.17.02.01.04.03.06.04.05.03.1.06.16.09.03.01.05.02.08.03.06.02.11.04.17.05.02,0,.04.01.07.02.08.02.16.03.25.03,0,0,0,0,0,0,.09,0,.19-.01.28-.03.01,0,.02,0,.03,0,.02,0,.04-.02.06-.02.05-.01.1-.03.14-.05.03-.01.07-.03.1-.05.04-.02.08-.04.12-.07.03-.02.07-.05.1-.07.01-.01.03-.02.05-.03l16.18-14.48,3.57,13.83s.01.04.02.05c.01.03.02.07.03.1.02.05.04.09.06.13.01.03.03.05.04.08.03.05.07.1.11.15,0,.01.02.03.03.04,0,0,0,0,0,0,.06.06.12.12.19.17.02.01.04.03.06.04.05.03.1.06.15.09.03.01.05.02.08.04.05.02.11.04.17.05.02,0,.05.01.07.02.08.02.16.03.25.03.07,0,.14,0,.21-.02.02,0,.04,0,.06-.01.02,0,.04,0,.06-.01.02,0,.04-.01.06-.02.05-.01.09-.03.14-.05.03-.02.07-.03.1-.05.04-.02.08-.04.11-.07.03-.02.07-.05.1-.08.01-.01.03-.02.04-.03l16.04-14.48,3.71,13.85s.01.03.02.05c.01.03.02.06.03.1.02.05.04.09.06.13.01.03.03.05.04.08.03.05.07.1.11.15,0,.01.02.02.03.04,0,0,0,0,0,0,.06.06.12.12.19.17.02.01.04.03.06.04.05.03.1.06.16.09.03.01.05.02.08.03.05.02.11.04.17.05.02,0,.04.01.07.02.08.02.16.03.25.03.07,0,.14,0,.21-.02.02,0,.04,0,.06-.01.02,0,.04,0,.07-.01.02,0,.03-.01.05-.02.05-.02.1-.03.14-.05.03-.01.07-.03.1-.05.04-.02.08-.05.11-.07.03-.02.07-.05.1-.07.01-.01.03-.02.04-.03l15.91-14.48,3.84,13.86s.01.03.02.05c.01.03.02.06.04.1.02.05.04.09.06.13.01.03.03.05.05.08.03.05.07.1.11.15,0,.01.02.02.03.04,0,0,0,0,0,0,.06.06.12.12.19.17.02.01.04.03.06.04.05.03.1.06.15.09.03.01.05.02.08.03.05.02.11.04.17.05.02,0,.05.01.07.02.08.02.16.03.24.03.07,0,.14,0,.21-.02.02,0,.04,0,.07-.01.02,0,.05,0,.07-.02.02,0,.03-.01.05-.02.05-.02.09-.03.14-.05.03-.02.07-.03.1-.05.04-.02.07-.05.11-.07.03-.02.07-.05.1-.08.01-.01.03-.02.04-.03l15.78-14.48,3.97,13.88s.01.03.02.05c.01.03.02.06.04.09.02.05.04.09.06.13.01.03.03.05.04.08.03.05.07.1.11.15.01.01.02.03.03.04,0,0,0,0,0,0,.06.06.12.12.19.16.02.01.04.03.06.04.05.03.1.06.15.09.03.01.05.02.08.03.05.02.11.04.16.05.02,0,.05.01.07.02.08.01.16.02.24.02.07,0,.14,0,.22-.02.02,0,.04,0,.07-.01.03,0,.05,0,.08-.02.02,0,.03-.01.05-.02.05-.02.09-.03.14-.05.04-.02.07-.03.1-.05.04-.02.07-.05.11-.07.04-.03.07-.05.1-.08.01,0,.02-.02.03-.03l17.2-15.93c.53-.49.57-1.33.07-1.86-.49-.53-1.33-.57-1.86-.07l-15.63,14.47-3.97-13.87s-.01-.02-.01-.04c-.01-.05-.03-.09-.05-.13-.02-.04-.03-.08-.05-.11-.02-.04-.04-.07-.07-.1-.03-.04-.05-.08-.09-.11,0-.01-.01-.02-.02-.03-.02-.02-.04-.03-.06-.05-.03-.03-.07-.06-.1-.09-.03-.03-.07-.05-.11-.07-.03-.02-.07-.04-.11-.06-.04-.02-.08-.04-.12-.05-.04-.01-.07-.03-.11-.04-.04-.01-.09-.02-.13-.03-.04,0-.08-.01-.12-.02-.04,0-.09,0-.13,0-.04,0-.08,0-.12,0-.05,0-.09.01-.14.03-.03,0-.05,0-.08.01-.01,0-.02.01-.04.01-.04.01-.09.03-.13.05-.04.02-.08.03-.11.05-.03.02-.07.04-.1.07-.04.03-.08.06-.12.09,0,0-.02.01-.03.02l-15.76,14.47-3.83-13.85s-.01-.03-.01-.04c-.01-.05-.03-.09-.05-.14-.02-.04-.03-.07-.05-.11-.02-.04-.05-.07-.07-.11-.03-.04-.05-.07-.08-.11,0-.01-.02-.02-.03-.04-.02-.02-.04-.03-.06-.05-.03-.03-.06-.06-.1-.09-.03-.03-.07-.05-.11-.08-.03-.02-.07-.04-.1-.06-.04-.02-.08-.04-.12-.05-.04-.01-.08-.03-.11-.04-.04-.01-.08-.02-.13-.03-.04,0-.08-.01-.12-.02-.04,0-.09,0-.13,0-.04,0-.08,0-.12,0-.05,0-.1.01-.14.02-.02,0-.05,0-.07.01-.01,0-.02.01-.04.01-.05.01-.09.03-.14.05-.04.02-.07.03-.11.05-.04.02-.07.04-.11.07-.04.03-.08.05-.11.08-.01,0-.02.02-.03.03l-15.89,14.47-3.7-13.84s-.01-.03-.02-.04c-.01-.05-.03-.09-.05-.13-.02-.04-.03-.08-.05-.11-.02-.04-.04-.07-.07-.11-.03-.04-.05-.08-.08-.11-.01-.01-.02-.03-.03-.04-.02-.02-.04-.03-.06-.05-.03-.03-.07-.06-.1-.09-.03-.03-.07-.05-.11-.07-.03-.02-.07-.04-.11-.06-.04-.02-.08-.04-.12-.05-.04-.02-.08-.03-.12-.04-.04-.01-.08-.02-.12-.03-.04,0-.09-.01-.13-.02-.04,0-.08,0-.12,0-.04,0-.09,0-.13,0-.04,0-.09.01-.13.02-.03,0-.05,0-.08.01-.02,0-.03.01-.04.02-.04.01-.09.03-.13.05-.04.02-.08.03-.12.05-.04.02-.07.04-.1.06-.04.03-.08.05-.12.09-.01,0-.02.02-.04.03l-16.03,14.47-3.57-13.82s-.01-.03-.02-.04c-.01-.05-.03-.09-.05-.13-.02-.04-.03-.08-.05-.11-.02-.04-.04-.07-.06-.1-.03-.04-.06-.08-.09-.12,0-.01-.02-.02-.03-.04-.01-.02-.03-.03-.05-.04-.04-.04-.07-.07-.11-.1-.03-.02-.06-.04-.09-.07-.04-.03-.08-.05-.12-.07-.03-.02-.07-.03-.1-.05-.04-.02-.09-.03-.13-.05-.04-.01-.07-.02-.11-.03-.05,0-.09-.02-.14-.02-.04,0-.08,0-.12,0-.04,0-.09,0-.13,0-.05,0-.09.01-.14.02-.02,0-.05,0-.07.01-.02,0-.03.01-.04.02-.05.01-.09.03-.13.05-.04.02-.08.03-.11.05-.04.02-.07.04-.11.07-.04.03-.08.05-.12.08-.01.01-.03.02-.04.03l-16.16,14.47-3.44-13.8s-.01-.03-.02-.05c-.01-.05-.03-.09-.05-.13-.02-.04-.03-.08-.05-.11-.02-.04-.04-.07-.07-.11-.03-.04-.05-.08-.08-.11-.01-.01-.02-.03-.03-.04-.02-.02-.04-.03-.05-.05-.03-.03-.06-.06-.09-.09-.04-.03-.07-.06-.11-.08-.03-.02-.06-.04-.1-.06-.04-.02-.09-.04-.13-.06-.03-.01-.07-.03-.1-.04-.04-.01-.09-.03-.14-.04-.04,0-.08-.01-.12-.02-.05,0-.09,0-.14,0-.04,0-.08,0-.12,0-.05,0-.09.01-.14.02-.02,0-.05,0-.07,0-.02,0-.03.01-.05.02-.04.01-.09.03-.13.05-.04.02-.08.03-.12.05-.04.02-.07.04-.11.06-.04.03-.08.05-.12.08-.01.01-.03.02-.04.03l-16.29,14.47-3.31-13.79s-.01-.03-.02-.05c-.01-.05-.03-.09-.05-.14-.02-.04-.03-.08-.05-.11-.02-.04-.04-.07-.06-.11-.03-.04-.05-.08-.08-.11-.01-.01-.02-.03-.03-.04-.01-.02-.03-.03-.05-.04-.03-.03-.07-.07-.1-.1-.03-.03-.06-.05-.1-.07-.04-.03-.07-.05-.11-.07-.04-.02-.07-.04-.11-.05-.04-.02-.08-.03-.13-.05-.04-.01-.07-.02-.11-.03-.05,0-.09-.02-.14-.02-.04,0-.08,0-.12,0-.04,0-.09,0-.13,0-.05,0-.09.01-.14.02-.02,0-.04,0-.06,0-.02,0-.03.01-.05.02-.05.01-.09.03-.14.05-.04.02-.07.03-.11.05-.04.02-.07.04-.11.07-.04.03-.08.05-.11.08-.01.01-.03.02-.04.03l-16.43,14.47-3.18-13.77s-.01-.03-.02-.05c-.01-.05-.03-.09-.05-.13-.02-.04-.03-.08-.05-.12-.02-.04-.04-.07-.06-.1-.03-.04-.06-.08-.09-.12-.01-.01-.02-.03-.03-.04-.01-.01-.03-.03-.04-.04-.04-.04-.07-.07-.11-.1-.03-.02-.06-.05-.09-.07-.04-.03-.08-.05-.12-.07-.03-.02-.07-.04-.1-.05-.04-.02-.09-.03-.13-.05-.04-.01-.07-.02-.11-.03-.05-.01-.09-.02-.14-.02-.04,0-.08,0-.12,0-.04,0-.09,0-.13,0-.05,0-.09,0-.14.02-.02,0-.04,0-.06,0-.02,0-.03.01-.05.02-.05.01-.09.03-.14.05-.04.02-.08.03-.11.05-.04.02-.07.04-.11.06-.04.03-.08.05-.11.08-.01.01-.03.02-.05.03l-16.56,14.46-3.05-13.76s-.01-.04-.02-.06c-.01-.05-.03-.09-.04-.13-.02-.04-.03-.08-.05-.12-.02-.04-.04-.07-.06-.11-.03-.04-.05-.08-.09-.12-.01-.01-.02-.03-.03-.04-.01-.01-.03-.02-.04-.04-.03-.04-.07-.07-.11-.1-.03-.02-.06-.05-.09-.07-.04-.03-.08-.05-.12-.07-.04-.02-.07-.04-.11-.05-.04-.02-.08-.03-.13-.05-.04-.01-.08-.02-.11-.03-.04,0-.09-.02-.13-.02-.04,0-.08,0-.12-.01-.04,0-.08,0-.12,0-.05,0-.1,0-.14.02-.02,0-.04,0-.06,0-.02,0-.04.01-.05.02-.05.01-.09.03-.14.05-.04.02-.08.03-.11.05-.04.02-.07.04-.11.06-.04.03-.08.05-.12.08-.02.01-.03.02-.05.03l-16.69,14.46-2.92-13.74s-.01-.04-.02-.06c-.01-.05-.03-.09-.04-.14-.01-.04-.03-.08-.05-.11-.02-.04-.04-.08-.06-.11-.02-.04-.05-.07-.08-.11-.01-.02-.02-.04-.04-.05-.01-.02-.03-.03-.05-.04-.03-.03-.06-.06-.09-.09-.03-.03-.07-.06-.11-.08-.03-.02-.06-.04-.1-.06-.04-.02-.08-.05-.12-.07-.03-.02-.07-.03-.11-.04-.04-.01-.09-.03-.13-.04-.04,0-.08-.02-.12-.02-.04,0-.09-.01-.13-.01-.04,0-.08,0-.12,0-.05,0-.09,0-.14.01-.02,0-.04,0-.06,0-.02,0-.04.01-.06.02-.04.01-.09.03-.13.04-.04.02-.08.03-.12.05-.04.02-.07.04-.11.06-.04.03-.08.05-.12.08-.02.01-.03.02-.05.03l-16.82,14.46-2.79-13.72s-.01-.04-.02-.06c-.01-.05-.03-.09-.04-.14-.01-.04-.03-.08-.05-.11-.02-.04-.04-.08-.06-.11-.02-.04-.05-.08-.08-.11-.01-.02-.02-.04-.04-.05-.01-.01-.03-.02-.04-.04-.03-.03-.06-.06-.1-.09-.03-.03-.06-.06-.1-.08-.03-.02-.07-.05-.11-.07-.04-.02-.07-.04-.11-.06-.04-.02-.08-.03-.12-.05-.04-.01-.08-.03-.12-.04-.04-.01-.09-.02-.13-.02-.04,0-.08-.01-.12-.01-.04,0-.08,0-.13,0-.05,0-.09,0-.14.01-.02,0-.04,0-.05,0-.02,0-.04.01-.06.02-.05.01-.09.03-.14.04-.04.01-.08.03-.12.05-.04.02-.07.04-.11.06-.04.02-.08.05-.12.08-.02.01-.04.02-.05.04l-16.95,14.46-2.66-13.71s-.01-.04-.02-.07c-.01-.04-.02-.09-.04-.13-.02-.04-.03-.08-.05-.12-.02-.04-.04-.07-.06-.1-.03-.04-.06-.09-.09-.13-.01-.02-.02-.03-.03-.05-.01-.01-.02-.02-.03-.03-.03-.04-.07-.07-.11-.1-.03-.03-.06-.05-.09-.07-.03-.03-.07-.05-.11-.07-.04-.02-.08-.04-.11-.06-.04-.02-.07-.03-.11-.04-.04-.02-.09-.03-.13-.04-.04,0-.07-.01-.11-.02-.05,0-.09-.01-.14-.02-.04,0-.07,0-.11,0-.05,0-.1,0-.15.01-.02,0-.03,0-.05,0-.02,0-.04.01-.06.02-.05.01-.09.02-.14.04-.04.01-.08.03-.12.05-.04.02-.07.04-.11.06-.04.03-.08.05-.12.08-.02.01-.04.02-.05.04l-18.82,15.93c-.42.36-.58.94-.39,1.46Zm4.84-1.77l14.35-12.15,2.35,12.15h-16.71Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 582.97,
  y: 160.38,
  width: 152.09,
  height: 3.72,
  transform: "translate(1318.03 324.48) rotate(180)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m608.67,146.1h126.39v14.27h-126.39v-14.27Zm124.88,1.51h-123.38v11.26h123.38v-11.26Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 712.74,
  y: 146.86,
  width: 1.51,
  height: 12.77
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 691.93,
  y: 146.86,
  width: 1.51,
  height: 12.77
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 671.11,
  y: 146.86,
  width: 1.51,
  height: 12.77
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 650.3,
  y: 146.86,
  width: 1.51,
  height: 12.77
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 629.48,
  y: 146.86,
  width: 1.51,
  height: 12.77
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "m322.72,164.1h268.1l-13.71-18.56h-240.68l-13.71,18.56Zm240.99-2.64h-16.89l7.93-12.28,8.96,12.28Zm-6.43-13.29h16.76l-7.81,12.27-8.95-12.27Zm-12.94,12.27l-8.84-12.27h16.76l-7.93,12.27Zm-2.52,1.02h-16.89l8.05-12.28,8.84,12.28Zm-19.38-1.02l-8.72-12.27h16.76l-8.04,12.27Zm-2.51,1.02h-16.89l8.16-12.28,8.73,12.28Zm-19.38-1.02l-8.61-12.27h16.76l-8.16,12.27Zm-2.51,1.02h-16.89l8.28-12.28,8.62,12.28Zm-19.39-1.02l-8.5-12.27h16.76l-8.27,12.27Zm-2.5,1.02h-16.89l8.39-12.28,8.5,12.28Zm-19.39-1.02l-8.38-12.27h16.76l-8.38,12.27Zm-2.5,1.02h-16.89l8.5-12.28,8.39,12.28Zm-19.39-1.02l-8.27-12.27h16.76l-8.5,12.27Zm-2.49,1.02h-16.89l8.62-12.28,8.28,12.28Zm-19.4-1.02l-8.16-12.27h16.76l-8.61,12.27Zm-2.49,1.02h-16.89l8.73-12.28,8.16,12.28Zm-19.23-1.27l-8.17-12.02h16.71l-8.55,12.02Zm-2.33,1.27h-17.22l8.86-12.31,8.36,12.31Zm-19.74-1.02l-7.93-12.27h16.76l-8.83,12.27Zm-2.48,1.02h-16.89l8.96-12.28,7.93,12.28Zm-19.41-1.02l-7.81-12.27h16.76l-8.95,12.27Zm-2.48,1.02h-16.89l9.07-12.28,7.82,12.28Zm240.76,0h-16.89l7.82-12.28,9.07,12.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "m590.8,160.38v557.5h23.86V160.38h-23.86Zm2.64,43.21h16.92l-16.92,18.64v-18.64Zm0,25.47l16.92,18.64h-16.92v-18.64Zm0,21.28h16.92l-16.92,18.65v-18.65Zm0,25.48l16.92,18.64h-16.92v-18.64Zm0,21.28h16.92l-16.92,18.64v-18.64Zm0,25.47l16.92,18.64h-16.92v-18.64Zm0,21.28h16.92l-16.92,18.65v-18.65Zm0,25.48l16.92,18.64h-16.92v-18.64Zm0,21.28h16.92l-16.92,18.64v-18.64Zm0,25.47l16.92,18.65h-16.92v-18.65Zm0,21.28h16.92l-16.92,18.64v-18.64Zm0,25.47l16.92,18.64h-16.92v-18.64Zm0,21.28h16.92l-16.92,18.65v-18.65Zm0,25.47l16.92,18.65h-16.92v-18.65Zm0,21.28h16.92l-16.92,18.64v-18.64Zm0,25.47l16.92,18.64h-16.92v-18.64Zm0,21.28h16.92l-16.92,18.65v-18.65Zm0,25.48l16.92,18.64h-16.92v-18.64Zm0,21.28h16.92l-16.92,18.64v-18.64Zm0,25.47l16.92,18.64h-16.92v-18.64Zm0,21.28h16.92l-16.92,18.65v-18.65Zm0,44.12v-18.64l16.92,18.64h-16.92Zm18.58-2.09l-16.92-18.65h16.92v18.65Zm0-21.28h-16.92l16.92-18.64v18.64Zm0-25.47l-16.92-18.64h16.92v18.64Zm0-21.28h-16.92l16.92-18.65v18.65Zm0-25.48l-16.92-18.64h16.92v18.64Zm0-21.28h-16.92l16.92-18.64v18.64Zm0-25.47l-16.92-18.64h16.92v18.64Zm0-21.28h-16.92l16.92-18.65v18.65Zm0-25.48l-16.92-18.64h16.92v18.64Zm0-21.28h-16.92l16.92-18.64v18.64Zm0-25.47l-16.92-18.65h16.92v18.65Zm0-21.28h-16.92l16.92-18.64v18.64Zm0-25.47l-16.92-18.64h16.92v18.64Zm0-21.28h-16.92l16.92-18.65v18.65Zm0-25.47l-16.92-18.65h16.92v18.65Zm0-21.28h-16.92l16.92-18.64v18.64Zm0-25.47l-16.92-18.64h16.92v18.64Zm0-21.28h-16.92l16.92-18.65v18.65Zm0-25.48l-16.92-18.64h16.92v18.64Zm0-21.28h-16.92l16.92-18.64v18.64Zm0-25.47l-16.92-18.64h16.92v18.64Zm0-21.28h-16.92l16.92-18.65v18.65Zm0-23.38h-18.58v-36.84h18.58v36.84Z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 567.32,
  y: 164.1,
  width: 7.83,
  height: 26.3
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "575.14 190.4 567.32 190.4 571.23 203.58 579.06 203.58 575.14 190.4"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 567.32,
  y: 167.26,
  width: 7.83,
  height: 23.14
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "570.29 200.42 567.32 190.4 575.14 190.4 578.12 200.42 570.29 200.42"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "579.06 203.58 604.19 203.58 604.19 164.1 575.14 164.1 575.14 190.4 579.06 203.58"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "578.12 200.42 575.14 190.4 575.14 167.26 590.8 167.26 590.8 200.42 578.12 200.42"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 561,
  y: 694.5,
  width: 20.38,
  height: 23.38
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 581.38,
  y: 694.5,
  width: 55.24,
  height: 23.38,
  transform: "translate(1218.01 1412.37) rotate(180)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 569.77,
  y: 307.46,
  width: 15.66,
  height: 11.69
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 585.42,
  y: 307.46,
  width: 42.44,
  height: 11.69,
  transform: "translate(1213.28 626.61) rotate(180)"
})), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 585.42,
  y: 317.83,
  width: 42.44,
  height: 2.64
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 569.77,
  y: 317.83,
  width: 15.66,
  height: 2.64
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 569.77,
  y: 213.95,
  width: 15.66,
  height: 11.69
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 585.42,
  y: 213.95,
  width: 42.44,
  height: 11.69,
  transform: "translate(1213.28 439.59) rotate(180)"
})), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 585.42,
  y: 224.32,
  width: 42.44,
  height: 2.64
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 569.77,
  y: 224.32,
  width: 15.66,
  height: 2.64
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 369.66,
  y: 162.78,
  width: 21.91,
  height: 7.08,
  transform: "translate(761.22 332.65) rotate(180)"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-10",
  points: "304.84 688.69 300 688.69 300 626.1 304.84 626.13 304.84 688.69"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 304.84,
  y: 626.13,
  width: 79.69,
  height: 62.56,
  transform: "translate(689.37 1314.82) rotate(180)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "428.44 508.42 507.67 508.41 542.84 596.94 463.61 596.94 428.44 508.42"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "432.54 542.54 417.63 504.97 437.12 492.19 441.95 499.56 428.44 508.42 463.61 596.94 456.1 601.87 336.94 679.98 302.66 627.69 432.54 542.54"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "437.12 492.19 516.36 492.19 521.18 499.56 441.95 499.56 437.12 492.19"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-10",
  points: "428.76 609.1 452.73 593.39 435.9 551.03 411.92 566.75 428.76 609.1"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-10",
  points: "397.26 629.75 421.24 614.03 404.4 571.68 380.43 587.39 397.26 629.75"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-10",
  points: "365.77 650.39 389.75 634.67 372.91 592.32 348.94 608.04 365.77 650.39"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-10",
  points: "339.52 667.6 358.25 655.32 341.42 612.97 315.04 630.26 339.52 667.6"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "411.92 566.75 411.92 566.75 435.91 551.02 437.57 555.2 417.34 568.46 411.92 566.75"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "428.76 609.1 411.92 566.75 417.34 568.46 430.86 602.46 428.76 609.1"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "380.43 587.39 380.43 587.39 404.42 571.67 406.08 575.85 385.85 589.11 380.43 587.39"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "397.26 629.75 380.43 587.39 385.85 589.11 399.36 623.11 397.26 629.75"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "348.94 608.04 348.94 608.04 372.92 592.31 374.58 596.49 354.35 609.75 348.94 608.04"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "365.77 650.39 348.94 608.04 354.35 609.75 367.87 643.75 365.77 650.39"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "315.04 630.26 317.44 628.68 341.43 612.96 343.09 617.14 321.14 631.53 315.04 630.26"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "315.04 630.26 339.52 667.6 340.79 661.5 321.14 631.53 315.04 630.26"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "428.44 508.42 507.67 508.41 521.18 499.56 441.95 499.56 428.44 508.42"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-10",
  points: "336.94 679.98 416.17 679.98 542.84 596.94 463.61 596.94 336.94 679.98"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "m302.07,612.91h4.7c1.14-.02,2.31.33,3.34,1.04.28.19,6.08,4.86,6.08,4.86l-10.08,6.6-4.04-12.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "m299.51,613.64c1.68-1.1,3.89-.9,5.66.31.28.19,8.29,6.65,8.29,6.65l-10.8,7.09-4.14-6.31c-1.8-2.74-1.36-6.21.98-7.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "m300.71,619.94c.87,1.33,2.49,1.8,3.62,1.06,1.13-.74,1.35-2.42.48-3.74-.87-1.33-2.49-1.8-3.62-1.06-1.13.74-1.35,2.42-.48,3.74Z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "m464.59,654.99c-1.45.59-3.03.06-3.53-1.18-.5-1.24.27-2.72,1.72-3.3,1.45-.59,3.03-.06,3.53,1.18.5,1.24-.27,2.72-1.72,3.3Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 446.19,
  y: 638.09,
  width: 25.44,
  height: 5.67,
  transform: "translate(881.68 -24.4) rotate(68.04)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "m455.06,631.37c-1.45.59-3.03.06-3.53-1.18-.5-1.24.27-2.72,1.72-3.3,1.45-.59,3.03-.06,3.53,1.18.5,1.24-.27,2.72-1.72,3.3Z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "m475.03,680.89c-2.36.95-4.94.09-5.75-1.93-.81-2.02.44-4.43,2.81-5.38,2.36-.95,4.94-.09,5.75,1.93.81,2.02-.44,4.43-2.81,5.38Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-11",
  x: 455.4,
  y: 660.36,
  width: 26.42,
  height: 9.23,
  transform: "translate(910.05 -18.34) rotate(68.04)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "m465.09,656.4c-2.36.95-4.94.09-5.75-1.93-.81-2.02.44-4.43,2.81-5.38,2.36-.95,4.94-.09,5.75,1.93.81,2.02-.44,4.43-2.81,5.38Z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "m635.52,686.26c10.88,0,19.7,10.33,19.7,23.07s-8.82,23.07-19.7,23.07h-11.92v-46.14h11.92Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-5",
  cx: 623.6,
  cy: 709.33,
  rx: 19.7,
  ry: 23.07
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-2",
  cx: 623.6,
  cy: 709.33,
  rx: 10.86,
  ry: 12.72
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-12",
  cx: 623.6,
  cy: 709.33,
  rx: 9.24,
  ry: 10.82
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "m586.42,677.45h77.93c2.93,0,5.31,2.38,5.31,5.31v27.22c0,2.93-2.38,5.31-5.31,5.31h-77.93v-37.84h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "m582.43,592.93h77.91c2.94,0,5.32,2.38,5.32,5.32v105.11h-83.23v-110.43h0Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 589.98,
  y: 606.14,
  width: 72.14,
  height: 38.52,
  transform: "translate(1252.1 1250.81) rotate(180)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 589.98,
  y: 606.14,
  width: 72.14,
  height: 8.42
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "m604.2,668.19h43.69c.88,0,1.6.72,1.6,1.6v3.11h-46.89v-3.11c0-.88.72-1.6,1.6-1.6Z",
  transform: "translate(1252.1 1341.08) rotate(180)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "m604.2,658.78h43.69c.88,0,1.6.72,1.6,1.6v3.11h-46.89v-3.11c0-.88.72-1.6,1.6-1.6Z",
  transform: "translate(1252.1 1322.26) rotate(180)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "m454.64,686.26c10.88,0,19.7,10.33,19.7,23.07s-8.82,23.07-19.7,23.07h-11.92v-46.14h11.92Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-5",
  cx: 442.72,
  cy: 709.33,
  rx: 19.7,
  ry: 23.07
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-2",
  cx: 442.72,
  cy: 709.33,
  rx: 10.86,
  ry: 12.72
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-12",
  cx: 442.72,
  cy: 709.33,
  rx: 9.24,
  ry: 10.82
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "m499.34,686.26c10.88,0,19.7,10.33,19.7,23.07s-8.82,23.07-19.7,23.07h-11.92v-46.14h11.92Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-5",
  cx: 487.42,
  cy: 709.33,
  rx: 19.7,
  ry: 23.07
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-2",
  cx: 487.42,
  cy: 709.33,
  rx: 10.86,
  ry: 12.72
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-12",
  cx: 487.42,
  cy: 709.33,
  rx: 9.24,
  ry: 10.82
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "m357.93,677.45h232.5v37.84h-237.81v-32.53c0-2.93,2.38-5.31,5.31-5.31Z",
  transform: "translate(943.06 1392.74) rotate(180)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "m556.29,686.26c10.88,0,19.7,10.33,19.7,23.07s-8.82,23.07-19.7,23.07h-11.92v-46.14h11.92Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-12",
  cx: 544.37,
  cy: 709.33,
  rx: 19.7,
  ry: 23.07
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-3",
  cx: 544.37,
  cy: 709.33,
  rx: 10.86,
  ry: 12.72
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-9",
  cx: 544.37,
  cy: 709.33,
  rx: 9.24,
  ry: 10.82
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "m540.57,709.33c0,4.86,2.74,8.98,6.52,10.34,3.78-1.36,6.52-5.48,6.52-10.34s-2.74-8.98-6.52-10.34c-3.78,1.36-6.52,5.48-6.52,10.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "m544.72,709.33c0,3.29,2.28,5.96,5.09,5.96,1.01,0,1.95-.35,2.74-.94.68-1.5,1.05-3.21,1.05-5.02s-.38-3.52-1.05-5.02c-.79-.59-1.74-.94-2.74-.94-2.81,0-5.09,2.67-5.09,5.96Z"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "m505.53,686.32c-2.22,0-4.01,1.8-4.01,4.01v9.03c0,2.22,1.8,4.01,4.01,4.01h-35.95c-2.21,0-4-1.79-4-4v-9.05c0-2.21,1.79-4.01,4.01-4.01h35.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "m544.29,681.41h-26.57v-84.48c0-2.21,1.79-4,4-4h60.71c2.21,0,4,1.79,4,4v106.43h-18.78c-2.33-12.55-11.87-21.95-23.29-21.95-.03,0-.05,0-.08,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "m582.89,644.67l-41.79-5.94c-1.18-.17-2.06-1.18-2.06-2.38v-27.79c0-1.33,1.08-2.41,2.41-2.41h41.44v38.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "m586.42,677.45h77.94c2.93,0,5.31,2.38,5.31,5.31v20.6h-83.25v-25.91h0Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 593.98,
  y: 695.06,
  width: 12.63,
  height: 8.3,
  transform: "translate(1200.59 1398.43) rotate(180)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 593.98,
  y: 686.26,
  width: 12.63,
  height: 4.4,
  transform: "translate(1200.59 1376.91) rotate(180)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 653.49,
  y: 686.26,
  width: 12.63,
  height: 4.4,
  transform: "translate(1319.62 1376.91) rotate(180)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 653.49,
  y: 695.06,
  width: 12.63,
  height: 8.3,
  transform: "translate(1319.62 1398.43) rotate(180)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 620.03,
  y: 696.61,
  width: 20.05,
  height: 5.21,
  transform: "translate(1260.1 1398.43) rotate(180)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "360.21 681.85 348.29 681.85 336.53 703.34 348.45 703.34 360.21 681.85"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "m375.4,686.26c10.88,0,19.7,10.33,19.7,23.07s-8.82,23.07-19.7,23.07h-11.92v-46.14h11.92Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-12",
  cx: 363.48,
  cy: 709.33,
  rx: 19.7,
  ry: 23.07
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-3",
  cx: 363.48,
  cy: 709.33,
  rx: 10.86,
  ry: 12.72
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-9",
  cx: 363.48,
  cy: 709.33,
  rx: 9.24,
  ry: 10.82
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "m359.68,709.33c0,4.86,2.74,8.98,6.52,10.34,3.78-1.36,6.52-5.48,6.52-10.34s-2.74-8.98-6.52-10.34c-3.78,1.36-6.52,5.48-6.52,10.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "m363.83,709.33c0,3.29,2.28,5.96,5.09,5.96,1.01,0,1.95-.35,2.74-.94.68-1.5,1.05-3.21,1.05-5.02s-.38-3.52-1.05-5.02c-.79-.59-1.74-.94-2.74-.94-2.81,0-5.09,2.67-5.09,5.96Z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "m420.11,686.26c10.88,0,19.7,10.33,19.7,23.07s-8.82,23.07-19.7,23.07h-11.92v-46.14h11.92Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-12",
  cx: 408.19,
  cy: 709.33,
  rx: 19.7,
  ry: 23.07
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-3",
  cx: 408.19,
  cy: 709.33,
  rx: 10.86,
  ry: 12.72
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-9",
  cx: 408.19,
  cy: 709.33,
  rx: 9.24,
  ry: 10.82
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "m404.39,709.33c0,4.86,2.74,8.98,6.52,10.34,3.78-1.36,6.52-5.48,6.52-10.34s-2.74-8.98-6.52-10.34c-3.78,1.36-6.52,5.48-6.52,10.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "m408.54,709.33c0,3.29,2.28,5.96,5.09,5.96,1.01,0,1.95-.35,2.74-.94.68-1.5,1.05-3.21,1.05-5.02s-.38-3.52-1.05-5.02c-.79-.59-1.74-.94-2.74-.94-2.81,0-5.09,2.67-5.09,5.96Z"
})), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "345.45 677.45 349.66 677.45 349.66 677.45 422.01 677.45 422.01 677.45 426.22 677.45 437.26 702.3 435.14 703.34 423.38 681.85 348.29 681.85 336.53 703.34 334.41 702.3 345.45 677.45"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "438.14 677.45 426.22 677.45 437.26 702.3 449.18 702.3 438.14 677.45"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-12",
  points: "447.06 703.34 435.14 703.34 437.26 702.3 449.18 702.3 447.06 703.34"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "m517.72,681.41v-3.97h68.7c2.22,0,4.01,1.79,4.01,4.01v21.91h-22.78c-2.33-12.55-11.87-21.95-23.29-21.95h-26.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "m517.72,667.9c-2.21,0-4,1.79-4,4v27.45c0,2.21,1.79,4.01,4.01,4.01h3.25c2.34-12.62,11.92-22.08,23.4-22.08s21.06,9.46,23.4,22.08h11.61c-2.47-20.05-17.2-35.46-35.01-35.46h-26.65Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 669.22,
  y: 614.56,
  width: 9.21,
  height: 22.07,
  transform: "translate(1347.65 1251.19) rotate(180)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: 570.13,
  y: 614.56,
  width: 9.21,
  height: 22.07,
  transform: "translate(1149.48 1251.19) rotate(180)"
}));

function SvgRentor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentor);
export default __webpack_public_path__ + "static/media/Rentor.bbeb68092a76250a89229d7cea83d391.svg";
export { ForwardRef as ReactComponent };